import { ModalProps } from "antd/lib/modal/Modal";
import { Input, InputNumber, message, Modal, Select, Spin, Switch } from "antd";
import Style from "./index.module.scss";
import React, { useContext, useEffect } from "react";
import Form, { useForm, useWatch } from "rc-field-form";
import FieldWithErrorHaveLabel from "../../../../../components/FieldWithErrorHaveLabel";

import { CourseContext } from "../../../Store";
import {
    convertMinutesToDHM,
    EditQuestionParams,
    getHouOptions,
    getMinOptions,
    getQuestionnaire,
    saveQuestionnaire,
    timeToMin,
    anewUpdateQuestionnaire
} from "../../../../../service/question";
import useRequestFn from "../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { errorMessage, isTrue } from "../../../../../service/service";
import StuPicker from "./Components/StuPicker";

interface Props extends ModalProps {
    onSuccess: () => void;
    id?: any;
    type: "add" | "republic";
}

interface FormProp {
    description: string;
    anonymityFlag: boolean;
    haveTime: boolean;
    d?: number;
    h?: number;
    m?: number;
    studentIds?: string[];
}

const Index = ({ onSuccess, onCancel, id, type, ...props }: Props) => {
    const [form] = useForm<FormProp>();

    const { course } = useContext(CourseContext);

    const [initData, { loading }] = useRequestFn(getQuestionnaire);

    useEffect(() => {
        if (id) {
            initData(id).then(res => {
                const saveObj: FormProp = {
                    haveTime: !!res?.validityTime,
                    anonymityFlag: isTrue(res.anonymityFlag),
                    description: res.description
                };
                if (res?.validityTime) {
                    const { days, hours, mine } = convertMinutesToDHM(
                        res?.validityTime
                    );
                    saveObj.d = days;
                    saveObj.h = hours;
                    saveObj.m = mine;
                }
                form.setFieldsValue(saveObj);
            });
        }
    }, [id]);

    const [saveAction, { loading: saveLoading }] =
        useRequestFn(saveQuestionnaire);

    const [republicAction, { loading: republicLoading }] = useRequestFn(
        anewUpdateQuestionnaire
    );

    // 重新发布
    async function onRepublish(data: FormProp) {
        const { studentIds } = data;
        const params: EditQuestionParams = {
            description: data.description,
            anonymityFlag: data.anonymityFlag ? "1" : "0",
            weekTimeId: course.weekTimeId,
            studentIds: studentIds || []
        };
        if (id) {
            params.id = id;
        }
        if (data.haveTime) {
            params.validityTime = timeToMin(
                data.d || 0,
                data.h || 0,
                data.m || 0
            );
        }
        try {
            // @ts-ignore
            await republicAction(params);
            onSuccess();
            ResultMessage.success("重新发布成功!");
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function onFinish(data: FormProp) {
        if (type === "republic") return onRepublish(data);

        const params: EditQuestionParams = {
            anonymityFlag: data.anonymityFlag ? "1" : "0",
            description: data.description,
            weekTimeId: course.weekTimeId
        };
        if (data.haveTime) {
            const all = timeToMin(data.d || 0, data.h || 0, data.m || 0);
            if (all > 0) {
                params.validityTime = all;
            }
        }
        if (id) {
            params.id = id;
        }
        try {
            await saveAction(params);
            onSuccess();
            message.success("保存成功");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const haveTime = useWatch("haveTime", form);

    return (
        <Modal
            {...props}
            onCancel={onCancel}
            maskClosable={false}
            okButtonProps={{
                loading: loading || saveLoading || republicLoading
            }}
            width={600}
            title="问卷活动"
            onOk={form.submit}>
            <Spin
                spinning={[saveLoading, republicLoading, loading].some(i => i)}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        {type === "republic" && id && (
                            <FieldWithErrorHaveLabel
                                label="通知范围"
                                name="studentIds"
                                align="middle">
                                <StuPicker
                                    id={id}
                                    weekTimeId={course.weekTimeId}
                                />
                            </FieldWithErrorHaveLabel>
                        )}
                        {type === "add" && (
                            <FieldWithErrorHaveLabel
                                label="标题"
                                name="description"
                                align="middle">
                                <Input maxLength={50} />
                            </FieldWithErrorHaveLabel>
                        )}

                        <FieldWithErrorHaveLabel
                            align="middle"
                            label="是否匿名"
                            name="anonymityFlag">
                            {({ value, onChange }) => (
                                <Switch checked={value} onChange={onChange} />
                            )}
                        </FieldWithErrorHaveLabel>
                        <FieldWithErrorHaveLabel
                            align="middle"
                            label="是否限时"
                            name="haveTime">
                            {({ value, onChange }) => (
                                <Switch checked={value} onChange={onChange} />
                            )}
                        </FieldWithErrorHaveLabel>
                        {haveTime && (
                            <div className={Style.timeRow}>
                                持续时间
                                <Form.Field name="d" preserve={false}>
                                    <InputNumber
                                        min={0}
                                        className={Style.timeInput}
                                    />
                                </Form.Field>
                                天
                                <Form.Field name="h" preserve={false}>
                                    <Select className={Style.timeInput}>
                                        {getHouOptions().map(i => {
                                            return (
                                                <Select.Option
                                                    key={i}
                                                    value={i}>
                                                    {i}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Field>
                                小时
                                <Form.Field name="m" preserve={false}>
                                    <Select className={Style.timeInput}>
                                        {getMinOptions().map(i => {
                                            return (
                                                <Select.Option
                                                    key={i}
                                                    value={i}>
                                                    {i}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Field>
                                分钟
                            </div>
                        )}
                    </Form>
                </div>
            </Spin>
        </Modal>
    );
};
export default Index;
